module.exports = __webpack_public_path__ + "img/1.563102ad.jpg";